import { render, staticRenderFns } from "./CommentsSubPage.vue?vue&type=template&id=c5f7eef4&"
import script from "./CommentsSubPage.vue?vue&type=script&lang=ts&"
export * from "./CommentsSubPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports